// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1Ttg8","footer":"ChangeClinic_footer__3x7G0"};